import { HttpClientModule } from '@angular/common/http';
import { Inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { AvailableBsVersions, setTheme } from 'ngx-bootstrap/utils';
import {
    AppSettings,
    BootstrapVersion,
    LoginExceptionRedirectFactory,
    LoginExceptionRedirectToken,
    PacApiModule,
} from 'pac-api';

import { AddressPreviewComponent } from './address/address-preview/address-preview.component';
import { AddressComponent } from './address/address.component';
import { DynamicAddressComponent } from './address/dynamic-address/dynamic-address.component';
import { PhoneFieldComponent } from './address/phone/field/phone-field.component';
import { PhoneComponent } from './address/phone/phone.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { AppComponent } from './app.component';
import { CART_NAME } from './cart-name';
import { CompleteComponent } from './complete/complete.component';
import { ContactInfoComponent } from './contact-info/contact-info.component';
import { DemographicsComponent } from './contact-info/demographics/demographics.component';
import { CopyValueDirective } from './contact-info/individual/copy-value.directive';
import { IndividualComponent } from './contact-info/individual/individual.component';
import { EqualValidatorDirective } from './contact-info/password/equal-validator.directive';
import { PasswordComponent } from './contact-info/password/password.component';
import { RecaptchaComponent } from './contact-info/recaptcha/recaptcha.component';
import { EmailValidateDirective } from './email/email-validate.directive';
import { EmailComponent } from './email/email.component';
import { IndividualAffiliationsComponent } from './individual-affiliations/individual-affiliations.component';
import { LoginComponent } from './login/login.component';
import {
    InstructorDemographicsComponent,
} from './prospect-demographics/instructor-demographics/instructor-demographics.component';
import { ProspectDemographicsComponent } from './prospect-demographics/prospect-demographics.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ReferralComponent } from './referral/referral.component';
import { SharedModule } from './shared/shared.module';
import { TermsComponent } from './terms/terms.component';
import { AdditionalAcknowledgementComponent } from './terms/additional-acknowledgement/additional-acknowledgement.component';

@NgModule({
    declarations: [
        AddressComponent,
        AddressPreviewComponent,
        AppComponent,
        CompleteComponent,
        ContactInfoComponent,
        CopyValueDirective,
        DemographicsComponent,
        DynamicAddressComponent,
        EmailComponent,
        EmailValidateDirective,
        EqualValidatorDirective,
        IndividualAffiliationsComponent,
        IndividualComponent,
        InstructorDemographicsComponent,
        LoginComponent,
        PasswordComponent,
        PhoneComponent,
        PhoneFieldComponent,
        ProspectDemographicsComponent,
        RecaptchaComponent,
        RedirectComponent,
        ReferralComponent,
        TermsComponent,
        AdditionalAcknowledgementComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        TypeaheadModule.forRoot(),
        ModalModule.forRoot(),
        AlertModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TooltipModule.forRoot(),
        BsDropdownModule.forRoot(),
        PacApiModule.forRoot({
            skipAppSettings: true,
        }),
        AppRoutingModule,
        SharedModule,
        FontAwesomeModule
    ],
    exports: [],
    providers: [
        {
            provide: LoginExceptionRedirectToken,
            useFactory: (settings: AppSettings) => LoginExceptionRedirectFactory(settings.appUrl),
            deps: [AppSettings]
        },
        {
            provide: CART_NAME,
            useValue: null,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(settings: AppSettings, @Inject(BootstrapVersion) bsVersion: AvailableBsVersions) {
        setTheme(bsVersion);
        settings.appUrl = '/signup';
    }

}
